import StepButton from "../atoms/StepButton";

/**
 * DateNavigator - 前後ステップボタンとカレンダーピッカーを横並びにするナビゲーター
 *
 * 「◀ 前日 / カレンダー / 翌日 ▶」や「◀ 前月 / カレンダー / 翌月 ▶」のような
 * 日付ナビゲーション UI を汎用的に組み立てる。
 * カレンダーピッカーは children として渡す（DatePickerField を想定）。
 *
 * @param {string}    prevLabel - 前に移動するボタンのラベル（例: '◀ 前日'）
 * @param {string}    nextLabel - 次に移動するボタンのラベル（例: '翌日 ▶'）
 * @param {function}  onPrev    - 前に移動するボタンのクリックハンドラ
 * @param {function}  onNext    - 次に移動するボタンのクリックハンドラ
 * @param {string}    gapClass  - 子要素間の gap クラス（デフォルト: 'gap-2'）
 * @param {ReactNode} children  - カレンダーピッカー（DatePickerField）
 */
function DateNavigator({ prevLabel, nextLabel, onPrev, onNext, gapClass = "gap-2", children }) {
  return (
    <div className={`flex items-center ${gapClass}`}>
      <StepButton label={prevLabel} onClick={onPrev} />
      {children}
      <StepButton label={nextLabel} onClick={onNext} />
    </div>
  );
}

export default DateNavigator;
